import React from 'react';
import PropTypes from 'prop-types';

const Plus01 = ({color = 'currentColor', ...props}) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 1L7 13M13 7L1 7"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

Plus01.propTypes = {
  color: PropTypes.string,
};

export default Plus01;
